<bn-loading-overlay></bn-loading-overlay>
<h5>Conglomerado</h5>
<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            <div *ngIf="podeCadastrarConglomerado" class="col-auto">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/habilitacao/conglomerado/novo']"
                  ngbTooltip="Selecione esta opção para incluir um Conglomerado."><i class="fa fa-file-signature">
                  </i> Cadastrar Conglomerado
                </button>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>
            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false)" (click)="buscar(false)"
                    [disabled]="!pesquisaForm.valid">Pesquisar
                </button>
            </div>
        </div>
        <div class="row mt-4">
            <div class="bn-form-group col-md-4">
                <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
                <select *ngIf="podeConsultarConglomerado" id="agenteFinanceiro" class="form-select" formControlName="agenteFinanceiro">
                  <option [ngValue]="null">Todos</option>
                  <option *ngFor="let agente of agentesFinanceiros"
                    [ngValue]="agente.id">{{ agente.sigla }}
                  </option>
                </select>

                <select *ngIf="!podeConsultarConglomerado" disabled id="agenteFinanceiro" class="form-select" formControlName="agenteFinanceiro">
                  <ng-container *ngFor="let agente of agentesFinanceiros">
                    <option
                        selected *ngIf="agente?.cnpj == cnpjUsuario">{{ agente.sigla }}
                    </option>
                  </ng-container>
                </select>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label">Data início conglomerado:</label>
                <bn-datepicker
                    name="dataInicial"
                    idInput="dataInicial"
                    formControlName="dataInicial"
                    ngDefaultControl>
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label">Data fim conglomerado:</label>
                <bn-datepicker
                    name="dataFinal"
                    idInput="dataFinal"
                    formControlName="dataFinal"
                    ngDefaultControl>
                </bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label">Codigo conglomerado:</label>
                <input id="codigoConglomerado" 
                    class="form-control text-uppercase" 
                    placeholder="Ex: CGL001"
                    formControlName="codigo"
                    maxlength="6"
                    ngDefaultControl>
            </div>
            <div class="bn-form-group col-md-2">
                <label class="form-label">Situação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Exibe a situação do Agente Financeiro no conglomerado"></i></label>
                <select class="form-select" formControlName="situacao" ngDefaultControl>
                    <option *ngFor="let situacao of situacoes"
                        [ngValue]="situacao.value">{{ situacao.label }}
                    </option>
                </select>
            </div>
        </div>
    </form>
</div>
<app-conglomerado-listagem
    [conglomerados]="conglomerados"
    [msgSemResultado]="msgSemResultado"
    [dataHoraResultado]="dataHoraResultado"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    (aoMudarPagina)="mudancaPagina($event)"
    [podeCadastrarConglomerado]="podeCadastrarConglomerado"
    (exportarListaConglomerado)="exportarListaConglomerado()">
</app-conglomerado-listagem>
